import { IconCalendar } from "@tabler/icons-react";
import AppContext from "Context/appContext";
import { format } from "date-fns";
import { useContext } from "react";

import Button from "components/Button";
import IssueList from "containers/Cart/IssueList";
import "containers/Completion/index.css";
import { formatTo12Hour, isFieldFilled } from "utils";

const Completion = () => {
  const {
    productCartDetail,
    setProducts,
    allProducts,
    setProgressState,
    setFormData,
    setProductCartDetail,
    appointmentDetail,
    formdata,
    notificationWay,
    setNotificationWay,
    productCartData,
    setProductCartData,
    buttonClicked,
    reactHookFormData,
    setDefaultStore,
    setSelectedStoreDetails,
    setSelectedBookingPage,
    setToggle,
    setAppointmentDetail,
    isWebView,
    setButtonClicked,
    othersWorkflow,
    setOthersWorkflow,
    setIsButtonClicked,
    setIsBillable,
    isBillable,
    bookingList,
    setSelectedCategory,
    setPrevState,
    setPrevStateCategory,
    setProgressStateCategory,
    setEmailVerificationId,
    setEmailVerificationToken,
    setIsEmailVerified,
    setEmailVerificationPending,
    setEmailVerificationError,
  } = useContext(AppContext);

  let m_id = null;
  let model = null;

  if (productCartData && productCartData?.device_name) {
    m_id = String(productCartDetail?.services[0]?.device_id);
    model = productCartDetail?.brand?.models.find((ele) => ele.rd_device_id === m_id);
  } else if (!productCartData) {
    m_id = String(productCartDetail?.services[0]?.model);
    model = productCartDetail?.brand?.models.find((ele) => ele._id === m_id);
  }

  const resetStates = () => {
    setProducts(allProducts);
    setProgressState(0);
    setFormData({ firstName: "", lastName: "", phone: "", email: "", notes: "", option: "", model: "" });
    setProductCartDetail(null);
    setProductCartData(null);
    if(bookingList.length > 1) {
      setDefaultStore(null);
      setSelectedStoreDetails(null);
      setToggle(false);
      setSelectedBookingPage({});
    }
    setNotificationWay('');
    reactHookFormData.reset();
    setButtonClicked(null);
    setOthersWorkflow(false);
    setIsButtonClicked(false);
    setIsBillable(false);
    setAppointmentDetail({
      date: appointmentDetail?.date || "",
      start: "",
      end: "",
    })
    setPrevState([]);
    setSelectedCategory(null);
    setPrevStateCategory([]);
    setProgressStateCategory(0);
    // Reset email verification states for new request
    setEmailVerificationId(null);
    setEmailVerificationToken(null);
    setIsEmailVerified(false);
    setEmailVerificationPending(false);
    setEmailVerificationError("");
    sessionStorage.removeItem('menuOption');
  };

  return (
    <>
      <div className="quote-end !rd-quote-ml-0 xs:!rd-quote-ml-0 xs:!rd-quote-max-h-[500px] md:!rd-quote-max-h-[635px] quote-mobile-reciept rd-quote-overflow-auto">
        <div className="quote-end-width">
          <div className="quote-col rd-quote-justify-center rd-quote-text-center rd-quote-items-center rd-quote-gap-1 rd-quote-mb-4">
            <span className="rd-quote-inline-block">
              <img
                className="rd-quote-w-[125px] rd-quote-h-[110px]"
                alt={"p"}
                src="/CircleCheck.png"
              />
            </span>
            <div className="tquote-text3 rd-quote-mt-1 rd-quote-text-center">
              {(buttonClicked === 'appointment' ? 'Thank you for booking an Appointment with us.' : 'Thank you for requesting a Quote!')}
            </div>
            <div className="quote-text1 rd-quote-text-center rd-quote-pr-6 rd-quote-pl-6 rd-quote-mt-1">
            
            {(buttonClicked === 'appointment' && (notificationWay === 'sms' || notificationWay === 'email'))
              ? `Your appointment has been confirmed! We're excited to fix your device and make it brand-new.`
              : (buttonClicked === 'quote' && (notificationWay === 'sms' || notificationWay === 'email'))
              ? `Your quote is on its way to your inbox!`
              : `Our team will be in touch shortly to provide you with the details of the ${buttonClicked}.`
            }
            </div>
          </div>
          <div className="quote-cart-header">Information</div>
          {/* Item */}
          <div className="quote-row quote-row-gap quote-direction-column quote-gap-mobile-screen">
            {/* Brand */}
            {((!formdata.model || othersWorkflow) && !isBillable &&
              <div className="quote-cart-item">
                <div className="quote-cart-item-section">
                  {productCartDetail?.brand?.picture && (
                    <div className="quote-cart-item-img">{
                      productCartDetail?.brand?.picture && <img
                        className="rd-quote-max-w-8 rd-quote-max-h-8"
                        alt="P"
                        src={productCartDetail?.brand?.picture}
                      />
                    }

                    </div>
                  )}
                  <div className="quote-cart-item-title">
                    <div className="quote-text1">Brand</div>
                    <div className={`quote-text1 rd-quote-font-normal ${isWebView ? 'rd-quote-max-w-[200px]' : 'rd-quote-max-w-[150px]'}`}>
                      {" "}
                      {productCartDetail?.brand?.name || productCartDetail?.services[0]?.manufacturer_name || formdata.model || 'Others'}
                    </div>
                  </div>

                </div>
              </div>
            )}

            {/* Model */}
            {!isBillable && (
            <div className="quote-cart-item">
              <div className="quote-cart-item-section">
                {(productCartDetail?.model?.picture || model?.picture) &&
                  <div className="quote-cart-item-img">
                    <img
                      className="rd-quote-max-w-8 rd-quote-max-h-8"
                      alt="P"
                      src={productCartDetail?.model?.picture ? productCartDetail?.model?.picture : model?.picture}
                    />
                  </div>}
                <div className="quote-cart-item-title">
                  <div className="quote-text1">Model</div>
                  <div className={`quote-text1 rd-quote-font-normal ${isWebView ? 'rd-quote-max-w-[200px]' : 'rd-quote-max-w-[150px]'}`}>
                    {productCartDetail?.model?.name || productCartDetail?.services[0]?.device_name || formdata?.model || model?.name || productCartData.device_name || 'Others'}
                  </div>
                </div>
              </div>
            </div>
            )}

            {/* Category */}
            {isBillable && (
            <div className="quote-cart-item">
              <div className="quote-cart-item-section">
                {productCartDetail?.category?.picture &&
                  <div className="quote-cart-item-img">
                    <img
                      className="rd-quote-max-w-8 rd-quote-max-h-8"
                      alt="P"
                      src={productCartDetail?.category?.picture}
                    />
                  </div>}
                <div className="quote-cart-item-title">
                  <div className="quote-text1">Category</div>
                  <div className={`quote-text1 rd-quote-font-normal ${isWebView ? 'rd-quote-max-w-[200px]' : 'rd-quote-max-w-[150px]'}`}>
                    {productCartData.device_name}
                  </div>
                </div>
              </div>
            </div>
            )}

          </div>
          {appointmentDetail && Object.values(appointmentDetail).every(value => isFieldFilled(value)) && buttonClicked === 'appointment' && (
            <div className="quote-cart-item rd-quote-mt-4">
              <div className="quote-cart-item-section">
                <div className="quote-cart-item-img">
                  <IconCalendar className="rd-quote-text-gray-500" />
                </div>
                <div className="quote-cart-item-title ">
                  <div className="quote-text1">Appointment Date & Time</div>
                  <div className="quote-text1 rd-quote-font-normal rd-quote-truncate rd-quote-max-w-[250px]">
                    {format(new Date(appointmentDetail?.date), "MM-dd-yyyy")},{" "}
                    {appointmentDetail?.start && formatTo12Hour(appointmentDetail.start)} - {appointmentDetail?.end && formatTo12Hour(appointmentDetail.end)}
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* issues header */}
          {productCartDetail?.services && (
            <>
              <div className="quote-cart-issue-header">
                <div className="quote-text1">
                  Issues({productCartDetail?.services?.length})
                </div>
              </div>
              <div className={`${isWebView ? 'quote-completion-scroll' : ''} !rd-quote-max-h-[90px] lg:!rd-quote-max-h-[172px]`}>
                <IssueList />
              </div>
            </>
          )}
        </div>
        {/* bottom  */}
        {isWebView && <div className="rd-quote-flex rd-quote-mt-2 rd-quote-flex-col rd-quote-justify-between">
          {/* <div className="rd-quote-flex rd-quote-flex-row rd-quote-justify-between rd-quote-inline-flex rd-quote-items-center rd-quote-bg-gray-100 rd-quote-rounded rd-quote-px-2 ">
          <p className="rd-quote-text-gray-800 rd-quote-text-base rd-quote-font-normal rd-quote-leading-Normal">
            Sub Total
          </p>
          <p className="rd-quote-text-gray-800 rd-quote-text-base rd-quote-font-medium  rd-quote-leading-normal">
            ${productCartDetail?.totalPrice === undefined ? 0 : productCartDetail?.totalPrice}
          </p>
        </div> */}
          <Button text={"Make Another Request"} submit={resetStates} />
        </div>}
      </div>
      {!isWebView &&
        <div>
          <Button text={"Make Another Request"} submit={resetStates} />
        </div>}
    </>
  );
};

export default Completion;
